module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/joanna-shimada-d23c47cd6f5f933e83eb8e4456dee690.png";